import React from 'react';
import ReactDOM from 'react-dom';
import { MenuApp } from '../components/MenuApp';

const mountNode = document.getElementById('menu-app-root');

ReactDOM.hydrate(<MenuApp />, mountNode);
